import { render, staticRenderFns } from "./IconSvgScale.vue?vue&type=template&id=22e597e6&scoped=true&"
import script from "./IconSvgScale.vue?vue&type=script&lang=js&"
export * from "./IconSvgScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e597e6",
  null
  
)

export default component.exports